import { render, staticRenderFns } from "./YyPTP.vue?vue&type=template&id=16ba5449&"
import script from "./YyPTP.vue?vue&type=script&lang=js&"
export * from "./YyPTP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports